<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3" *ngIf="saveButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Examiner Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Add New Examiner Data
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="updateButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Examiner Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Update Examiner Data
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Examiner Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Delete Examiner Data
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Initial</mat-label>
                            <!-- <mat-select [disabled]="isreaddelete" required formControlName="Initial">
                                <mat-option value="MS">Miss.</mat-option>
                                <mat-option value="MR">MR.</mat-option>
                                <mat-option value="MRS">MRS.</mat-option>
                                <mat-option value="DR">DR.</mat-option>
                                <mat-option value="PF">Prof.</mat-option>
                            </mat-select> -->
                            <mat-select [disabled]="isreaddelete" #select5913 class="colorblack"
                                formControlName="Initial">
                                <mat-select-filter *ngIf="select5913.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="initialList"
                                    (filteredReturn)="filterinitialList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filterinitialList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Initial'].touched && teacherForm.controls['Initial'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>First Name</mat-label>
                            <input  maxlength="150" [readonly]="isreaddelete"  matInput formControlName="FirstName">
                            <!-- <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['FirstName'].touched && teacherForm.controls['FirstName'].errors?.required">
                                Mandatory
                            </mat-error> -->
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['FirstName'].touched && teacherForm.controls['FirstName'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Middle Name</mat-label>
                            <input  maxlength="150" [readonly]="isreaddelete" [readonly]="isreaddelete"  matInput
                                formControlName="MiddleName">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['MiddleName'].touched && teacherForm.controls['MiddleName'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['MiddleName'].touched && teacherForm.controls['MiddleName'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Last Name</mat-label>
                            <input  maxlength="150" [readonly]="isreaddelete"  matInput formControlName="LastName">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['LastName'].touched && teacherForm.controls['LastName'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['LastName'].touched && teacherForm.controls['LastName'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Full Name</mat-label>
                            <input  maxlength="150" [readonly]="isreaddelete"  matInput formControlName="FullName">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['FullName'].touched && teacherForm.controls['FullName'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['FullName'].touched && teacherForm.controls['FullName'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Gender</mat-label>
                            <mat-select [disabled]="isreaddelete" #select5913 class="colorblack"
                                formControlName="Gender">
                                <mat-select-filter *ngIf="select5913.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="GenderList"
                                    (filteredReturn)="filterGenderList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filterGenderList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Gender'].touched && teacherForm.controls['Gender'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Date of Birth</mat-label>
                            <input [readonly]="isreaddelete"  matInput [matDatepicker]="dobPicker"
                                formControlName="DOB">
                            <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dobPicker></mat-datepicker>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['DOB'].touched && teacherForm.controls['DOB'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Email</mat-label>
                            <input  maxlength="150" [readonly]="isreaddelete"  matInput formControlName="Email">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Email'].touched && teacherForm.controls['Email'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Email'].touched && teacherForm.controls['Email'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Mobile Number</mat-label>
                            <input [readonly]="isreaddelete || isreadupdate" required matInput formControlName="MobileNo"
                                maxlength="10">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['MobileNo'].touched && teacherForm.controls['MobileNo'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['MobileNo'].touched && teacherForm.controls['MobileNo'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Aadhaar No.</mat-label>
                            <input [readonly]="isreaddelete"  matInput formControlName="AadharNo"
                                maxlength="12">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['AadharNo'].touched && teacherForm.controls['AadharNo'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['AadharNo'].touched && teacherForm.controls['AadharNo'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>PAN No.</mat-label>
                            <input placeholder="LISKA9333K" maxlength="10" [readonly]="isreaddelete"  matInput formControlName="PANNo">
                            <!-- <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['PANNo'].touched && teacherForm.controls['PANNo'].errors?.required">
                                Mandatory
                            </mat-error> -->
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['PANNo'].touched && teacherForm.controls['PANNo'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>OSAC ID</mat-label>
                            <input [readonly]="isreaddelete" matInput formControlName="OSACID">
                        </mat-form-field>
                    </div>
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Teacher Type</mat-label>
                            <mat-select (selectionChange)="getCollege($event.value)" [disabled]="isreaddelete" #select111 class="colorblack"
                                formControlName="TeacherType">
                                <mat-select-filter *ngIf="select111.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="TeacherTypeList"
                                    (filteredReturn)="filterTeacherTypeList =$event"></mat-select-filter>
                                <mat-option  
                                *ngFor="let item of filterTeacherTypeList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>College</mat-label>
                            <mat-select [disabled]="isreaddelete" required #select23 placeholder="CoCode"
                                class="colorblack" formControlName="CgCode">
                                <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CgName'" [array]="collegeList"
                                    (filteredReturn)="filteredCollegeList =$event">
                                </mat-select-filter>
                                <mat-option  *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                                    {{item.CgCode}} - {{item.CgName}}
                                </mat-option>
                            </mat-select>

                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['CgCode'].touched && teacherForm.controls['CgCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Faculty</mat-label>
                            <mat-select multiple [disabled]="isreaddelete" required #select33 placeholder="" class="colorblack"
                                formControlName="FcCode" (selectionChange)="onFacultyChange($event.value)">
                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                    [displayMember]="'FcDesc'" [array]="fcCodeList"
                                    (filteredReturn)="filteredListFcCode =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode">
                                    {{item.FcCode}} - {{item.FcDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['FcCode'].touched && teacherForm.controls['FcCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Department</mat-label>
                            <mat-select
                                [disabled]="isreaddelete"
                                multiple
                                required
                                #select13
                                placeholder="Department"
                                class="colorblack"
                                formControlName="DeptCode"
                                (selectionChange)="onDeptChange()">   
                                <mat-select-filter
                                    *ngIf="select13.focused"
                                    [placeholder]="'Filter'"
                                    [displayMember]="'DeptName'"
                                    [array]="DepartmentList"
                                    (filteredReturn)="filteredDepartmentList = $event">
                                </mat-select-filter>
                                <mat-option
                                    *ngFor="let item of filteredDepartmentList"
                                    [value]="item.DeptCode">
                            
                                    {{item.DeptName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['DeptCode'].touched &&
                                    teacherForm.controls['DeptCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Taught Subject</mat-label>
                            <mat-select [disabled]="isreaddelete" multiple required #select12 placeholder="CoCode"
                                class="colorblack" formControlName="ToughtSubject">
                                <mat-select-filter *ngIf="select12.focused" [placeholder]="'Filter'"
                                    [displayMember]="'DmSubEsId'" [array]="mapSubjectList"
                                    (filteredReturn)="filteredmapSubjectList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredmapSubjectList" [value]="item.DmSubEsId">
                                    {{item.EsName}}({{item.CoName}}-{{item.DmEmSrNo}})
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['ToughtSubject'].touched && teacherForm.controls['ToughtSubject'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>PG Qualification Year</mat-label>
                            <input  maxlength="4" [readonly]="isreaddelete" required matInput formControlName="PGQualiPassYear">
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['PGQualiPassYear'].touched && teacherForm.controls['PGQualiPassYear'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Designation</mat-label>
                            <mat-select [disabled]="isreaddelete" #select593 class="colorblack"
                                formControlName="Designation">
                                <mat-select-filter *ngIf="select593.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="DesignationList"
                                    (filteredReturn)="filterDesignationList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filterDesignationList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Designation'].touched && teacherForm.controls['Designation'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>HOD</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="isHOD">
                                <mat-option [value]="1">Yes</mat-option>
                                <mat-option [value]="0">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['isHOD'].touched && teacherForm.controls['isHOD'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Approve Status PG</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="ApprovalStPG">
                                <mat-option [value]="1" (click)="PgApproval('1')">Yes</mat-option>
                                <mat-option [value]="0" (click)="PgApproval('0')">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['ApprovalStPG'].touched && teacherForm.controls['ApprovalStPG'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Approve Status UG</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="ApprovalStUG">
                                <mat-option [value]="1" (click)="UgApproval('1')">Yes</mat-option>
                                <mat-option [value]="0" (click)="UgApproval('0')">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['ApprovalStUG'].touched && teacherForm.controls['ApprovalStUG'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>PG Guide</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="Guide">
                                <mat-option [value]="1">Yes</mat-option>
                                <mat-option [value]="0">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Guide'].touched && teacherForm.controls['Guide'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                     <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>PHD Guide</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="PhdGuide">
                                <mat-option [value]="1">Yes</mat-option>
                                <mat-option [value]="0">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['PhdGuide'].touched && teacherForm.controls['PhdGuide'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Debar</mat-label>
                            <mat-select [disabled]="isreaddelete" required formControlName="Debar">
                                <mat-option [value]="1">Yes</mat-option>
                                <mat-option [value]="0">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Debar'].touched && teacherForm.controls['Debar'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2" *ngIf="updateButton">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Status</mat-label>
                            <mat-select [disabled]="isreaddelete" #select593 class="colorblack"
                                formControlName="TeacherStatus">
                                <mat-select-filter *ngIf="select593.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="TstatusList"
                                    (filteredReturn)="filterTstatusList =$event"></mat-select-filter>
                                    <mat-option  [value]="'Y'">
                                   {{''}}
                                </mat-option>
                                <mat-option *ngFor="let item of filterTstatusList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error class="margin_tp"
                                *ngIf="teacherForm.controls['Debar'].touched && teacherForm.controls['Debar'].errors?.required">
                                Mandatory
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" style="min-width: 190px;">
                            <label style="font-weight: 500; margin-bottom: 4px;">UG Experience</label>
                            <div style="display: flex; gap: 15px;">
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Years</mat-label>
                                    <input  maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Yrs"
                                        formControlName="UGExpYears" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['UGExpYears'].touched && teacherForm.controls['UGExpYears'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Month</mat-label>
                                    <input maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Mon"
                                        formControlName="UGExpMonths" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['UGExpMonths'].touched && teacherForm.controls['UGExpMonths'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Days</mat-label>
                                    <input maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Days"
                                        formControlName="UGExpDays" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['UGExpDays'].touched && teacherForm.controls['UGExpDays'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-6" style="min-width: 90px;">
                            <label style="font-weight: 500; margin-bottom: 4px;">PG Experience</label>
                            <div style="display: flex; gap: 16px;">
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Years</mat-label>
                                    <input  maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Yrs"
                                        formControlName="PGExpYears" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['PGExpYears'].touched && teacherForm.controls['PGExpYears'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Months</mat-label>
                                    <input  maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Mon"
                                        formControlName="PGExpMonths" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['PGExpMonths'].touched && teacherForm.controls['PGExpMonths'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" style="width: 150px;">
                                    <mat-label>Days</mat-label>
                                    <input  maxlength="2" [readonly]="isreaddelete" required matInput placeholder="Days"
                                        formControlName="PGExpDays" style="font-size: 12px; padding: 4px;">
                                    <mat-error class="margin_tp"
                                        *ngIf="teacherForm.controls['PGExpDays'].touched && teacherForm.controls['PGExpDays'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-12 d-flex align-items-center" *ngIf="isUgApproval">
                        <label class="me-2 mb-0">Upload UG Approval Letter</label>
                        <input #fileUploader type="file" formControlName="UGApproval" (change)="UGApproval($event)" class="form-control-file me-2" />
                        <p class="file-name mb-0" (click)="showbaseUGFile()" *ngIf="FileDataUG">
                          Uploaded File: <span class="blue_col">UG Approval</span>
                        </p>
                      </div> -->
                      <div class="col-sm-12" *ngIf="isUgApproval">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                          <label class="mb-0 me-2">Upload UG Approval Letter</label>
                          <input #fileUploader type="file" formControlName="UGApproval" (change)="UGApproval($event)" class="form-control-file me-2" />
                          <span class="file-name mb-0 text-primary" (click)="showbaseUGFile()" *ngIf="FileDataUG">
                            Uploaded File: UG Approval
                          </span>
                        </div>
                      </div>
                    <div class="col-sm-12 mt-3" *ngIf="isPgApproval">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                          <label class="mb-0 me-2">Upload PG Approval Letter</label>
                          <input #fileUploader type="file" formControlName="PGApproval" (change)="PGApproval($event)" class="form-control-file me-2" />
                          <span class="file-name mb-0 text-primary" (click)="showbasePGFile()" *ngIf="FileDataPG">
                            Uploaded File: PG Approval
                          </span>
                        </div>
                      </div>
                    <div class="col-sm-6 hidden mt-3">
                        <label>Photo </label>
                        <!-- <input class="ml-3" type="file"> -->
                        <input #fileUploader type="file" formControlName="TeacherPhoto" (change)="TeacherPhoto($event)" />
                   
                    </div>
                    <div class="col-sm-6 hidden mt-3">
                        <label class="mr-3">Sign </label>
                        <input #fileUploader type="file" formControlName="TeacherSign" (change)="TeacherSign($event)" />
                   
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Save" type="button" *ngIf="saveButton"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="save()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                            <button id="Update" type="button" *ngIf="updateButton"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="update()" [disabled]="updateButtonDisabled">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                    Update
                                </span>
                            </button>
                            <button id="Delete" type="button" *ngIf="deleteButton" (click)="DeletetheRecord()"
                                class="btn btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    Delete
                                </span>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>